const galleryId = 26;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": {"en": ""},
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_511088296a.jpg","sh_716728030a.jpg","sh_716728030_3.jpg","sh_716728030_4.jpg","sh_716728030_1.jpg","sh_716728030_2.jpg","sh_93462220_2.jpg","sh_1527552890.jpg","sh_1108315907.jpg","sh_1507076756.jpg","sh_1680226489.jpg","sh_1015348405.jpg","sh_1505786330.jpg","sh_1301948821.jpg","sh_1307277547.jpg","sh_1797489817.jpg","sh_129331361.jpg","sh_1683481240.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Gingivitis/Periodontitis'));

group = ["sh_1710200266.jpg","sh_1710200269.jpg","sh_1669842172.jpg","sh_1417027964.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Peri-implantitis'));

group = ["sh_1645118599.jpg","sh_690358765.jpg","sh_1780338626.jpg","sh_1645118596.jpg","sh_1530693836.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
